import React from 'react';
import { observer } from 'mobx-react';

// Components
import List from 'components/drill-down-layout/components/list';
import ListItem from 'components/drill-down-layout/components/list/components/list-item';
import Header from './components/header';
import Technician from './components/technician';

// Icons
import PatientIcon from 'assets/icons/patient.svg';


const PharmacyTechniciansList = ({
  pharmacyTechniciansRouteStore,
  pharmacyTechniciansStore,
  setFilterValue,
  listPharmacyTechnicians,
  rootRoute,
}) => (
  <List
    header={<Header
      pharmacyTechniciansRouteStore={pharmacyTechniciansRouteStore}
      setFilterValue={setFilterValue}
    />}
    isReady={!pharmacyTechniciansRouteStore.http.listingTechnicians || pharmacyTechniciansStore.pharmacyTechnicians.size}
    onBottomThreshold={listPharmacyTechnicians}
  >
    {
      pharmacyTechniciansStore.dataAsArray.map(technician => (
        <ListItem
          key={technician.id}
          title={`${technician.firstName} ${technician.lastName}`}
          isActive={pharmacyTechniciansRouteStore.activeTechnicianId === technician.id}
          iconStyle={{width: '50px', height: '50px'}}
          icon={
            <img
              alt='technician'
              className='technician-view-icon-preview'
              src={PatientIcon}
            />
          }
          url={`${rootRoute}/${technician.id}`}
        >
          <Technician
            pharmaciesCaption={pharmacyTechniciansRouteStore.getPharmaciesCountCaption(technician)}
          />
        </ListItem>
      ))
    }
  </List>
);

export default observer(PharmacyTechniciansList);
